import React from "react";
import { getPhotographyConsentLabel } from "../shared/utils/photographyConsent";

/**
 * Compact roster badge for child photography / media consent on a User profile.
 * @param {{ consent?: boolean | null, title?: string }} props
 */
export default function PhotographyConsentBadge({ consent = null, title }) {
  const tone = consent === true ? "yes" : consent === false ? "no" : "unset";
  const label = getPhotographyConsentLabel(consent);
  const defaultTitle =
    consent === false
      ? "Parent declined photography / media release on this child's profile."
      : consent === true
        ? "Parent consented to photography / media release on this child's profile."
        : "Photography / media release not recorded on this child's profile.";
  return (
    <span className={`photography-consent-badge photography-consent-badge--${tone}`} title={title || defaultTitle}>
      {label}
    </span>
  );
}
